import { render, staticRenderFns } from "./PlatformDescription.vue?vue&type=template&id=e43d74ea&scoped=true"
import script from "./PlatformDescription.vue?vue&type=script&lang=js"
export * from "./PlatformDescription.vue?vue&type=script&lang=js"
import style0 from "./PlatformDescription.vue?vue&type=style&index=0&id=e43d74ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43d74ea",
  null
  
)

export default component.exports